import React from "react";
import axios from "axios";

export const countriesApi = async () => {
  try {
    let url = "https://visapro-api.tcore.online/api/v1/countries";

    const response = await axios.get(url);
    const countries = {
      data: response.data,
    };
    return countries;
  } catch (error) {
    const countries = {
      error: error,
    };
    return countries;
  }
};
